<template>
  <OnboardingInfo @next="handleClick">
    <template #heading>
      <span class="text-gray-400">Copyright is automatic.</span>
      <br />
      <span class="text-gray-800">Proof of ownership isn’t.</span>
    </template>
    <template #body>
      <p>
        Copyright exists from creation. But every dispute, every claim turns on
        the same question:
        <span class="font-medium italic">
          can you prove first authorship?
        </span>
      </p>
      <p class="mt-[18px]">Without being on the record, you can’t.</p>
    </template>
  </OnboardingInfo>
</template>

<script setup lang="ts">
import OnboardingInfo from '@/features/onboarding/components/OnboardingInfo.vue'
import { useCompleteStepMutation } from '@/shared/graphql/legacy/generated'
import { useOnboardingStore } from '@/features/onboarding/store'

const { mutate: completeStep } = useCompleteStepMutation()

const onboardingStore = useOnboardingStore()

const handleClick = () => {
  completeStep({ step: 5 })

  onboardingStore.goToNextStep()
}
</script>
